export default {"src":"/_next/static/media/logo.1c0119d6.svg","height":34,"width":200};